import { useUserStore } from '@/store';

import { type BoundaryProps, ErrorBoundary } from './ErrorBoundary';

export const ErrorBoundaryUser = (props: BoundaryProps) => {
  const logout = useUserStore((state) => state.logout);

  return (
    <ErrorBoundary
      {...props}
      errorMessage="User-related error"
      redirectTo="/login"
      retryButtonText="Back to Login"
      onRetry={() => {
        logout();
        window.location.reload();
      }}
    />
  );
};
